import React, { memo } from 'react';
import { AnalyticsProvider, MasterPage as MasterPageShared, useAuthentication } from '@cp-shared-15/frontend-ui';
import { landingPagePath, loginAnalyticsPath, registrationPagePath } from 'components/navigation/paths';
import { useLocation } from 'react-router-dom';
import { NavigationBar } from 'components/navigation/NavigationBar';
import { LegalFooter } from 'components/footer/legal-footer';
import { IconFooter } from 'components/footer/icon-footer';
import { currentBrand } from 'config';
import { ChatbotWrapper } from 'components/chatbot';

const shouldDisplayChatbot = (isAuthenticated: boolean, isLandingPage: boolean): boolean => {
    return isAuthenticated || isLandingPage;
};

export const MasterPage: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const auth = useAuthentication();
    const isAuthenticated = auth?.isAuthenticated ?? false;
    const isAuthInitialized = auth !== undefined;

    return (
        <MasterPageComponent isAuthenticated={isAuthenticated} isAuthInitialized={isAuthInitialized}>
            {children}
        </MasterPageComponent>
    );
};

export const MasterPageComponent: React.FC<{
    isAuthenticated: boolean;
    isAuthInitialized: boolean;
    children: React.ReactNode;
}> = memo(({ isAuthenticated, isAuthInitialized, children }) => {
    const userGroup = isAuthenticated ? 'private' : undefined;
    const location = useLocation();
    const isLandingPage = location.pathname === landingPagePath();
    const shouldShowChatbot = isAuthInitialized && shouldDisplayChatbot(isAuthenticated, isLandingPage);

    return (
        <AnalyticsProvider
            market="ie"
            isAuthenticated={isAuthenticated}
            version="1"
            releaseDate="2020-11-20"
            language="ie"
            registrationPath={registrationPagePath()}
            loginPath={loginAnalyticsPath()}
            userGroup={userGroup}
            brand={currentBrand}
        >
            <MasterPageShared
                navigationBar={<NavigationBar />}
                iconFooter={<IconFooter />}
                legalFooter={<LegalFooter />}
            >
                {children}
                {shouldShowChatbot && <ChatbotWrapper />}
            </MasterPageShared>
        </AnalyticsProvider>
    );
});

MasterPageComponent.displayName = 'MasterPageComponent';
